"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuardianAbilityHandler = exports.GuardianActorAbilityFactory = exports.GuardianAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_2 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Settings_1 = require("../../Settings");
class GuardianAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Guardian;
        this.__typeName = "Guardian";
    }
}
exports.GuardianAbilityArgs = GuardianAbilityArgs;
let GuardianActorAbilityFactory = class GuardianActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Guardian", "AllAllies", 4);
    }
};
GuardianActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Guardian")
], GuardianActorAbilityFactory);
exports.GuardianActorAbilityFactory = GuardianActorAbilityFactory;
let GuardianAbilityHandler = class GuardianAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const level = container.getLevel(ability.invokerId);
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                const buffSequence = sequence.pushSequence("sequential");
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(targetId => {
                    container.applyBuff({
                        sequence: buffSequence
                            .push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "YellowHexagonShield"))
                            .pushSequence("sequential"),
                        creatorId: ability.invokerId,
                        targetId,
                        duration: Duration_1.Duration.Turns(4),
                        effect: new core_2.LinkedEffectsEffectArgs([
                            new core_2.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.AllDamageResistance, Settings_1.BASE_LEVEL_ADR * container.getLevel(ability.invokerId)),
                            new core_2.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Toughness, container.getPercentOfBaseAttributeScore(targetId, 10, "Toughness")),
                        ], false),
                    });
                });
            }
        });
    }
};
GuardianAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Guardian)
], GuardianAbilityHandler);
exports.GuardianAbilityHandler = GuardianAbilityHandler;
